export interface HeldEmailSelectionModel {
  selectedIds: Set<string>;
  actionableIds: string[];
  onChange: (selectedIds: Set<string>) => void;
}

export function updateHeldEmailSelection(
  model: HeldEmailSelectionModel,
  id: string,
  selected: boolean
): void {
  const next = new Set(model.selectedIds);
  if (selected) next.add(id);
  else next.delete(id);
  model.onChange(next);
}
